import EtchSubHeroModule from './EtchSubHeroModule.component';

export default EtchSubHeroModule;
